import { Outlet } from 'react-router-dom';

import { useAccounts } from '@/hooks/useAccounts';

export default function AuthRequired() {
  const { isAuthenticated } = useAccounts();

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
